import React from "react"
import Layout from "../components/layout/layout"
import Feature from "../components/fullfeature"
import Gallery from "../components/gallery"
import Hero from "../components/hero"
import Image from "gatsby-image"
import { graphql } from 'gatsby'
import { Helmet } from "react-helmet"

export default data => {
  const feature = {
    headline: "Bio Feature Headline",
    text: data.data.sanityPages._rawContent[0].text,
    image: data.data.sanityPages.content[0].picture.asset.fluid.src,
    fluid: data.data.sanityPages.content[0].picture.asset.fluid
  }

  return (
    <Layout>
      <Helmet title={`Rajiv Satyal - ${data.data.sanityPages.title}`} />
      <Image fluid={feature.fluid} objectFit="none" />
      <Feature feature={feature} />
    </Layout>
  )
}

export const query = graphql`
  query RajivInSFQuery {
    sanityPages(slug: { current: { eq: "rajiv-in-sf" } }) {
      id
      hero_subtitle
      hero_title
      hero_video
      title
      _rawContent(resolveReferences: { maxDepth: 10 })
      content {
        ... on SanityBio {
          picture {
            asset {
              fluid(maxWidth: 700) {
                ...GatsbySanityImageFluid
                src
              }
            }
          }
        }
      }
      hero_bg {
        hotspot {
          x
          y
        }

        asset {
          fluid(maxWidth: 1920) {
            ...GatsbySanityImageFluid
            src
          }
        }
      }
    }
  }
`
